<template>
  <div class="card">
    <div class="nav-tabs card-body">
      <span>Accounts, IMAPs, &amp; Proxies</span>
      &nbsp;
      <button class="btn btn-primary exp-button" data-toggle="modal" data-target="#modal-add-client-account">Add New Account</button>
    </div>
    
    <paged-api-table
      @click="detailsClicked"
      module="Client-Accounts"
      default-sort="email ASC"
      v-bind:filter="filter"
      v-bind:columns="accountColumns"
      v-bind:refresh-for-id="clientsRefreshForId"
      v-bind:per-page="accountsPerPage">
    </paged-api-table>
    
    <add-client-account @added="onClientAdded" v-bind:client-id="clientId"></add-client-account>
    
    <div class="modal modal-blur fade" id="modal-acct-details" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Account Details</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>
          <div class="modal-body" v-if="accountDetails">
            Email: {{accountDetails.email}}<br />
            Login Type: {{accountDetails.type}}
            
            <div v-if="accountDetails.type == 'imap' || accountDetails.type == 'gmail'">
              IMAP Host: {{accountDetails.loginInfo.host}}<br />
              IMAP Port: {{accountDetails.loginInfo.port}}<br />
              IMAP Username: {{accountDetails.loginInfo.username}}<br />
              IMAP Password: {{accountDetails.loginInfo.password}}<br />
              IMAP SSL: {{accountDetails.loginInfo.ssl}}
            </div>
            
            Proxy: {{accountDetails.proxy}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AddClientAccount from "./AddClientAccount.vue";
  import PagedApiTable from "./PagedApiTable.vue";
  import $ from 'jquery';
  
  export default {
    props: {
      clientId: String
    },
  
    data() {
      return {
        filter: { clientId: this.clientId },
        
        accountDetails: null,
        clientsRefreshForId: null,
        
        accountColumns: [
          { key: "email", "text": "Email", type: "String" },
          { key: "type", "text": "Login Type", type: "String" },
          { key: "proxy", "text": "Proxy", type: "String" },
          { key: "details", "text": "Details", type: "Event" },
          { key: "delete", "text": "Delete", type: "Delete", id: "id" },
        ],
        
        accountsPerPage: 5
      };
    },
    
    methods: {
      editInfo() {
        this.editing = true;
      },
      
      saveInfo() {
        this.editing = false;
      },
      
      onClientAdded(id) {
        this.clientsRefreshForId = "" + id;
      },
      
      detailsClicked(data) {
        this.accountDetails = data.item.item;
        this.accountDetails.loginInfo = JSON.parse(this.accountDetails.login);
        
        $("#modal-acct-details").modal("show");
      }
    },
    
    components: {
      AddClientAccount,
      PagedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ImapList.vue